import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'shared/lib/redux';
import { Asset } from 'shared/api/retail';

import { getAquaEndpointUrl } from './constants';
import { normalizeAquaUserLicensesResponse } from './utils';
import { AquaUserLicensesResponse } from './types';

export const aquaApi = createApi({
  reducerPath: 'aqua',
  baseQuery: baseQuery(getAquaEndpointUrl),
  endpoints: (builder) => ({
    getAquaUserLicenses: builder.query<
      { transformedResponse: Asset[]; rawResponse: AquaUserLicensesResponse },
      void
    >({
      query: () => `users/v3/user/licenses`,
      transformResponse: (response: AquaUserLicensesResponse) => ({
        transformedResponse: normalizeAquaUserLicensesResponse(response),
        rawResponse: response,
      }),
    }),
  }),
});

export const { useGetAquaUserLicensesQuery } = aquaApi;
